import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import './app.scss';

import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useLocation,
} from 'react-router-dom';

import FooterComponent from './components/footer';
import { FeedbackPopup } from './components/feedback';
import BrochureComponent from './components/brochure/brochure';
import FaqComponent from './components/faq';
import PrivacyComponent from './components/privacy';
import NoMatch from './components/nomatch';

const BlogComponent = React.lazy(() => import('./components/blog'));
const OrderComponent = React.lazy(() => import('./components/order/order'));

import ReactGA from 'react-ga4';
import LinkedInTag from 'react-linkedin-insight';

LinkedInTag.init('1784228');
ReactGA.initialize([{ trackingId: 'G-G6LXRF4171' }, { trackingId: 'AW-11218358744' }]);

function Analytics() {
    // const location = useLocation();
    // const orderIdRegex = /[0-9a-f]{24}/;
    // const formattedLocation = location.pathname.replace(orderIdRegex, 'id');
    // ReactGA.send({ hitType: 'pageview', page: formattedLocation });

    window.scrollTo(0, 0);
    return null;
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function App() {
    const query = useQuery();
    const queryCoupon = query.get('rabatt');

    if (queryCoupon) {
        console.log('setting coupon code to', queryCoupon);
        sessionStorage.setItem('couponCode', queryCoupon);
    }

    const DEFAULT_TITLE = 'Svensk Portkod - där du säkert ändrar din portkod';

    const TITLES = {
        'faq': 'Svensk Portkod - Frågor och svar',
        'blogg': 'Svensk Portkod - Blogg',
        'personuppgifter': 'Svensk Portkod - Personuppgiftspolicy',
        'order': 'Svensk Portkod - Meddela ändring',
    };

    const location = useLocation()
    useEffect(() => {
        const first = location.pathname.split('/')[1];
        document.title = TITLES[first] ?? DEFAULT_TITLE
    }, [location]);

    return (
        <div>
            {/* <CookieComponent /> */}
            <Analytics />
            <Suspense fallback={<div className="sp-white" style={{minHeight: '100vh'}}>Laddar...</div>}>
                <Routes>
                    <Route path="/" element={<BrochureComponent />} />
                    <Route path="/faq" element={<FaqComponent />} />
                    <Route path="/personuppgifter" element={<PrivacyComponent />} />
                    <Route path="/blogg/*" element={<BlogComponent />} />
                    <Route path="/blog" element={<Navigate to="/blogg" replace />} />
                    <Route path="/order/*" element={<OrderComponent />} />
                    <Route path="*" element={<NoMatch />} />
                </Routes>
            </Suspense>
            <FooterComponent />
            <FeedbackPopup />
        </div>
    );
}


const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(<Router><App /></Router>);
